import React, { useEffect, useState } from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
} from "@react-pdf/renderer";
import Logo from "../../../../../../Styles/imagenes/Logo Maquinaria.jpg";
import { FormatMoney } from "../../../../../../Helpers/FormatNumber";
import { GetText, GetArrKey } from "../../../../../../Helpers/GetKey";
import request from "../../../../../../Helpers/API";
import Swal from "sweetalert2";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
  },
  titulo: {
    backgroundColor: "#477c2c",
    height: 57,
    marginTop: 51,
    textAlign: "center",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 60,
  },
  tituloTexto: {
    fontSize: 20,
    marginLeft: 40,
    fontFamily: "RobotoFamily",
  },
  imagenContainer: {
    position: "absolute",
    top: 0,
    left: 30,
  },
  logoImagen: {
    width: 150,
  },
  texto: {
    fontSize: 8,
  },
});

const DatosPrincipales = ({ folio, vendedor }) => {
  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 238 }}>
          <Text>FOLIO</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>PERSONA QUE CAPTURA</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>SUCURSAL</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          justifyContent: "space-between",
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        <View style={{ width: 238 }}>
          <Text>{folio}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{vendedor.vendedor}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{vendedor.sucursal}</Text>
        </View>
      </View>
    </View>
  );
};
const DatosGenerales = ({ datosgenerales }) => {
  return (
    <View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 238 }}>
          <Text>RFC</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>TIPO DE PERSONA</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>CURP</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        <View style={{ width: 238 }}>
          <Text>{datosgenerales.rfc}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{datosgenerales.tipopersona}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{datosgenerales.curp}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View>
          <Text>RAZON SOCIAL</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        <View>
          <Text>{datosgenerales.razonsocial}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 238 }}>
          <Text>SEXO</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>ESTADO CIVIL</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>REGIMEN CONYUGAL</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        <View style={{ width: 238 }}>
          <Text>{GetText(datosgenerales.sexo)}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{GetText(datosgenerales.estadocivil)}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{GetText(datosgenerales.regimenconyugal)}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 238 }}>
          <Text>EDAD</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>TIEMPO DE AGRICULTOR</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>NIVEL DE AGRUPACION</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
        }}
      >
        <View style={{ width: 238 }}>
          <Text>{datosgenerales.edad}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>{datosgenerales.tiempoagricultor}</Text>
        </View>
        <View style={{ width: 238 }}>
          <Text>
            {datosgenerales.agrupacion === "A"
              ? "Asociado"
              : datosgenerales.agrupacion === "I"
                ? "Individual"
                : datosgenerales.agrupacion === "G"
                  ? "Grupo"
                  : ""}
          </Text>
        </View>
      </View>
    </View>
  );
};
const renderContactos = (contactos) => {
  if (!contactos || contactos.length === 0) {
    return (
      <View>
        <View
          style={{
            backgroundColor: "#275027",
            color: "#fff",
            height: 20,
            marginLeft: 30,
            marginRight: 30,
            justifyContent: "center",
            alignItems: "center",
            fontSize: 14,
            fontFamily: "RobotoFamily",
            marginTop: 15,
          }}
        >
          <Text>CONTACTOS</Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            fontSize: 10,
            marginLeft: 30,
            marginRight: 30,
            backgroundColor: "#ccc",
            fontFamily: "RobotoFamily",
          }}
        >
          <Text>SIN INFORMACION</Text>
        </View>
      </View>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>CONTACTOS</Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 120 }}>
          <Text>MEDIO DE CONTACTO</Text>
        </View>
        <View style={{ width: 100 }}>
          <Text>CONTACTO</Text>
        </View>
        <View style={{ width: 150 }}>
          <Text>DATO </Text>
        </View>
        <View>
          <Text>COMENTARIOS </Text>
        </View>
      </View>

      <View>
        {contactos.map((contacto, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              fontSize: 10,
              marginLeft: 30,
              marginRight: 30,
              borderBottomWidth: 1,
              borderColor: "#afb69d",
              marginTop: 5,
            }}
          >
            <Text style={{ width: 120 }}>{contacto.mediocontacto}</Text>
            <Text style={{ width: 100 }}>{contacto.tipocontacto}</Text>
            <Text style={{ width: 150 }}>{contacto.valor}</Text>
            <Text>{contacto.comentarios}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};
const renderDomicilios = (domicilios) => {
  if (!domicilios || domicilios.length === 0) {
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>DOMICILIOS</Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 80 }}>
          <Text>MUNICIPIO</Text>
        </View>
        <View style={{ width: 80 }}>
          <Text>ESTADO</Text>
        </View>
        <View style={{ width: 70 }}>
          <Text>CP </Text>
        </View>
        <View style={{ width: 180 }}>
          <Text>COLONIA </Text>
        </View>
        <View style={{ width: 230 }}>
          <Text>DIRECCION </Text>
        </View>
        <View>
          <Text style={{ width: 74 }}>TIPO </Text>
        </View>
      </View>

      <View>
        {domicilios.map((domicilio, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              fontSize: 10,
              marginLeft: 30,
              marginRight: 30,
              borderBottomWidth: 1,
              borderColor: "#afb69d",
              marginTop: 5,
            }}
          >
            <Text style={{ width: 80 }}>{domicilio.municipio}</Text>
            <Text style={{ width: 80 }}>{domicilio.estado}</Text>
            <Text style={{ width: 70 }}>{domicilio.cp}</Text>
            <Text style={{ width: 180 }}>{domicilio.localidad}</Text>
            <Text style={{ width: 230 }}>{domicilio.direccion}</Text>
            <Text style={{ width: 74 }}>
              {GetText(domicilio.tipodomicilio)}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};
const renderCultivos = (cultivos) => {
  if (!cultivos || cultivos.length === 0) {
    return (
      <Text style={styles.paragraph}>No hay información de cultivos.</Text>
    );
  }

  // const meses = [
  //   "Enero",
  //   "Febrero",
  //   "Marzo",
  //   "Abril",
  //   "Mayo",
  //   "Junio",
  //   "Julio",
  //   "Agosto",
  //   "Septiembre",
  //   "Octubre",
  //   "Noviembre",
  //   "Diciembre",
  // ];

  // const tiposRiego = {
  //   B: "Bombeo",
  //   G: "Goteo",
  //   R: "Rodado",
  // };

  // const temporalOptions = {
  //   S: "Si",
  //   N: "No",
  // };

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>CULTIVOS</Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 102 }}>
          <Text>CULTIVO</Text>
        </View>
        <View style={{ width: 102 }}>
          <Text>HECTAREAS</Text>
        </View>
        <View style={{ width: 102 }}>
          <Text>RENDIMIENTO </Text>
        </View>
        <View style={{ width: 102 }}>
          <Text>MES COSECHA </Text>
        </View>
        <View style={{ width: 102 }}>
          <Text>PRECIO </Text>
        </View>
        <View>
          <Text style={{ width: 102 }}>TIPO DE RIEGO </Text>
        </View>
        <View>
          <Text style={{ width: 102 }}>TEMPORAL </Text>
        </View>
      </View>

      <View>
        {cultivos.map((cultivo, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              fontSize: 10,
              marginLeft: 30,
              marginRight: 30,
              borderBottomWidth: 1,
              borderColor: "#afb69d",
              marginTop: 5,
            }}
          >
            <Text style={{ width: 102 }}>{cultivo.cultivo}</Text>
            <Text style={{ width: 102 }}>{cultivo.hectareas}</Text>
            <Text style={{ width: 102 }}>{cultivo.rendimiento}</Text>
            <Text style={{ width: 102 }}>
              {cultivo.mescosecha}
              {/* {cultivo.mes_cosecha >= 1 && cultivo.mes_cosecha <= 12
                ? meses[parseInt(cultivo.mes_cosecha, 10) - 1]
                : ""} */}
            </Text>
            <Text style={{ width: 102 }}>{cultivo.precio}</Text>
            <Text style={{ width: 102 }}>{cultivo.tiporiego}</Text>
            <Text style={{ width: 102 }}>{cultivo.temporal}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};
const renderBalancePatrimonial = (balancepatrimonial) => {
  if (
    balancepatrimonial === undefined ||
    balancepatrimonial === null ||
    balancepatrimonial === 0
  )
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  else (
    <View></View>
  )

  const subtotalActivosCirculantes =
    balancepatrimonial.ac_cajabancos +
    balancepatrimonial.ac_clientes +
    balancepatrimonial.ac_deudoresdiversos +
    balancepatrimonial.ac_ivaporrecuperar +
    balancepatrimonial.ac_apoyodegobierno +
    balancepatrimonial.ac_inventariodeinsumos +
    balancepatrimonial.ac_inversionencultivos +
    balancepatrimonial.ac_otrosactivos;

  const subtotalActivosFijos =
    balancepatrimonial.af_terrenosenpropiedad +
    balancepatrimonial.af_terrenosenejidal +
    balancepatrimonial.af_construcciones +
    balancepatrimonial.af_maquinariayequipo +
    balancepatrimonial.af_equipodetransporte +
    balancepatrimonial.af_mobiliarioyequipo +
    balancepatrimonial.af_depresiaciones +
    balancepatrimonial.af_otrosactivos;

  const subtotalPasivosCirculantes =
    balancepatrimonial.pc_creditosdirectos +
    balancepatrimonial.pc_creditosdeavio +
    balancepatrimonial.pc_proveedores +
    balancepatrimonial.pc_acreedoresdiversos +
    balancepatrimonial.pc_impuestosycuotas +
    balancepatrimonial.pc_amortizaciones +
    balancepatrimonial.pc_otrospasivos;

  const subtotalPasivosFijos =
    balancepatrimonial.pf_creditosrefaccionarios +
    balancepatrimonial.pf_creditosdejdfm +
    balancepatrimonial.pf_otros;

  const totalActivos = subtotalActivosCirculantes + subtotalActivosFijos;
  const totalPasivos = subtotalPasivosCirculantes + subtotalPasivosFijos;
  const total = totalActivos - totalPasivos

  if (!balancepatrimonial || balancepatrimonial.length === 0) {
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>BALANCE PATRIMONIAL</Text>
      </View>

      <View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
            backgroundColor: "#ccc",
            fontFamily: "RobotoFamily",
          }}
        >
          <View style={{ width: 287 }}>
            <Text style={styles.label}>ACTIVOS CIRCULANTES</Text>
          </View>
          <View style={{ width: 70, textAlign: "center" }}>
            <Text style={styles.label}>$</Text>
          </View>

          <View style={{ width: 287 }}>
            <Text style={styles.label}>PASIVOS CIRCULANTES</Text>
          </View>
          <View style={{ width: 70, textAlign: "center" }}>
            <Text style={styles.label}>$</Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
          }}
        >
          <View style={{ width: 287 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>CAJA Y BANCOS</Text>
              <Text style={{ marginTop: 10 }}>CLIENTES</Text>
              <Text style={{ marginTop: 10 }}>DEUDORES DIVERSOS</Text>
              <Text style={{ marginTop: 10 }}>IVA POR RECUPERAR</Text>
              <Text style={{ marginTop: 10 }}>APOYO DE GOBIERNO</Text>
              <Text style={{ marginTop: 10 }}>INVENTARIO DE INSUMOS</Text>
              <Text style={{ marginTop: 10 }}>INVERSION EN CULTIVOS</Text>
              <Text style={{ marginTop: 10 }}>OTROS ACTIVOS CIRCULANTES</Text>
            </View>

          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 10 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_cajabancos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_clientes)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_deudoresdiversos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_ivaporrecuperar)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_apoyodegobierno)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_inventariodeinsumos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_inversionencultivos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.ac_otrosactivos)}</Text>
            </View>
          </View>

          <View style={{ width: 287 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>CREDITOS DIRECTOS</Text>
              <Text style={{ marginTop: 10 }}>CREDITOS DE AVIO</Text>
              <Text style={{ marginTop: 10 }}>PROVEEDORES</Text>
              <Text style={{ marginTop: 10 }}>ACREEDORES DIVERSOS</Text>
              <Text style={{ marginTop: 10 }}>IMPUESTOS Y CUOTAS</Text>
              <Text style={{ marginTop: 10 }}>AMORTIZACION DE REFACCIONES</Text>
              <Text style={{ marginTop: 10 }}>OTROS PASIVOS CIRCULANTES</Text>
            </View>

          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_creditosdirectos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_creditosdeavio)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_proveedores)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_acreedoresdiversos)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_impuestosycuotas)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_amortizaciones)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pc_otrospasivos)}</Text>
            </View>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
            fontFamily: "RobotoFamily",
            marginTop: 5,
          }}
        >
          <View style={{ width: 287 }}>
            <Text style={styles.label}>SUBTOTAL ACTIVOS CIRCULANTES</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(subtotalActivosCirculantes)}</Text>
          </View>

          <View style={{ width: 287 }}>
            <Text style={styles.label}>SUBTOTAL PASIVOS CIRCULANTES</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(subtotalPasivosCirculantes)}</Text>
          </View>
        </View>
      </View>

      <View style={{ marginTop: 10 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
            backgroundColor: "#ccc",
            fontFamily: "RobotoFamily",
          }}
        >
          <View style={{ width: 287 }}>
            <Text style={styles.label}>ACTIVOS FIJOS</Text>
          </View>
          <View style={{ width: 70, textAlign: "center" }}>
            <Text style={styles.label}>$</Text>
          </View>

          <View style={{ width: 287 }}>
            <Text style={styles.label}>PASIVOS FIJOS</Text>
          </View>
          <View style={{ width: 70, textAlign: "center" }}>
            <Text style={styles.label}>$</Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
          }}
        >


          <View style={{ width: 287 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>TERRENOS EN PROPIEDAD</Text>
              <Text style={{ marginTop: 10 }}>TERRENOS EN EJIDAL</Text>
              <Text style={{ marginTop: 10 }}>CONSTRUCCIONES</Text>
              <Text style={{ marginTop: 10 }}>MAQUINARIA Y EQUIPO</Text>
              <Text style={{ marginTop: 10 }}>EQUIPO DE TRANSPORTE</Text>
              <Text style={{ marginTop: 10 }}>MOBILIARIO Y EQUIPO DE OFICINA</Text>
              <Text style={{ marginTop: 10 }}>DEPRECIACIONES ACUMULADAS</Text>
              <Text style={{ marginTop: 10 }}>OTROS ACTIVOS FIJOS</Text>
            </View>

          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_terrenosenpropiedad)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_terrenosenejidal)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_construcciones)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_maquinariayequipo)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_equipodetransporte)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_mobiliarioyequipo)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_depresiaciones)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.af_otrosactivos)}</Text>
            </View>

          </View>

          <View style={{ width: 287 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>CREDITOS REFACCIONARIOS</Text>
              <Text style={{ marginTop: 10 }}>CREDITOS DE JDFM</Text>
              <Text style={{ marginTop: 10 }}>OTROS PASIVOS FIJOS</Text>
            </View>

          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <View style={{ marginTop: 5 }}>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pf_creditosrefaccionarios)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pf_creditosdejdfm)}</Text>
              <Text style={{ marginTop: 10 }}>{FormatMoney(balancepatrimonial.pf_otros)}</Text>
            </View>
          </View>

        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
            fontFamily: "RobotoFamily",
            marginTop: 5,
          }}
        >
          <View style={{ width: 287 }}>
            <Text style={styles.label}>SUBTOTAL ACTIVOS FIJO</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(subtotalActivosFijos)}</Text>
          </View>

          <View style={{ width: 287 }}>
            <Text style={styles.label}>SUBTOTAL PASIVOS FIJO</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(subtotalPasivosFijos)}</Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 10,
            fontFamily: "RobotoFamily",
            marginTop: 10,
            backgroundColor: "#ccc",
          }}
        >
          <View style={{ width: 287 }}>
            <Text style={styles.label}>TOTAL ACTIVOS</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(totalActivos)}</Text>
          </View>

          <View style={{ width: 287 }}>
            <Text style={styles.label}>TOTAL PASIVOS</Text>
          </View>
          <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
            <Text style={styles.label}>{FormatMoney(totalPasivos)}</Text>
          </View>
        </View>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            marginLeft: 30,
            marginRight: 30,
            fontSize: 14,
            fontFamily: "RobotoFamily",
            marginTop: 10,
            backgroundColor: "#ccc",
          }}
        >
          <View>
            <Text>ACTIVOS - PASIVOS</Text>
          </View>
          <View>{FormatMoney(total)}</View>
        </View>
      </View>
    </View>
  );
};
const renderEstadoResultados = (estadoresultados) => {
  if (
    estadoresultados === undefined ||
    estadoresultados === null ||
    estadoresultados === 0
  )
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  else (
    <View></View>
  )
  // const totalIngresos = estadoresultados
  //   .filter((item) => item.tipo === "IN")
  //   .reduce((total, item) => total + item.importe, 0);

  // const totalEgresos = estadoresultados
  //   .filter((item) => item.tipo === "EG")
  //   .reduce((total, item) => total + item.importe, 0);

  // const total = totalIngresos - totalEgresos;
  const totalIngresos =
    estadoresultados.in_agricolas +
    estadoresultados.in_ganado +
    estadoresultados.in_leche +
    estadoresultados.in_maquilas +
    estadoresultados.in_procampo +
    estadoresultados.in_rentas +
    estadoresultados.in_sueldos +
    estadoresultados.in_otros;
  const totalEgresos =
    estadoresultados.eg_agricolas +
    estadoresultados.eg_ganaderos +
    estadoresultados.eg_maquilas +
    estadoresultados.eg_terrenos +
    estadoresultados.eg_refaccionarios +
    estadoresultados.eg_intereses +
    estadoresultados.eg_impuestos +
    estadoresultados.eg_familiares +
    estadoresultados.eg_otros;

  const total = totalIngresos - totalEgresos

  if (!estadoresultados || estadoresultados.length === 0) {
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>INGRESOS Y EGRESOS</Text>
      </View>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: 30,
          marginRight: 30,
          fontSize: 10,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 287 }}>
          <Text style={styles.label}>INGRESOS</Text>
        </View>
        <View style={{ width: 70, textAlign: "center" }}>
          <Text style={styles.label}>$</Text>
        </View>

        <View style={{ width: 287 }}>
          <Text style={styles.label}>EGRESOS</Text>
        </View>
        <View style={{ width: 70, textAlign: "center" }}>
          <Text style={styles.label}>$</Text>
        </View>
      </View>

      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: 30,
          marginRight: 30,
          fontSize: 10,
        }}
      >

        <View style={{ width: 287 }}>
          <View style={{ marginTop: 5 }}>
            <Text style={{ marginTop: 10 }}>VENTA DE PRODUCTOS AGRICOLAS</Text>
            <Text style={{ marginTop: 10 }}>VENTA DE GANADO</Text>
            <Text style={{ marginTop: 10 }}>VENTA DE LECHE Y SUS DERIVADOS</Text>
            <Text style={{ marginTop: 10 }}>MAQUILAS</Text>
            <Text style={{ marginTop: 10 }}>PROCAMPO</Text>
            <Text style={{ marginTop: 10 }}>RENTAS</Text>
            <Text style={{ marginTop: 10 }}>SUELDOS</Text>
            <Text style={{ marginTop: 10 }}>OTROS INGRESOS</Text>
          </View>

        </View>
        <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
          <View style={{ marginTop: 5 }}>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_agricolas)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_ganado)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_leche)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_maquilas)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_procampo)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_rentas)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_sueldos)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.in_otros)}</Text>
          </View>

        </View>

        <View style={{ width: 287 }}>
          <View style={{ marginTop: 5 }}>
            <Text style={{ marginTop: 10 }}>COSTOS DE PRODUCCION AGRICOLA</Text>
            <Text style={{ marginTop: 10 }}>COSTOS DE PRODUCCION GANADEROS</Text>
            <Text style={{ marginTop: 10 }}>COSTOS DE PRODUCCION MAQUILAS</Text>
            <Text style={{ marginTop: 10 }}>RENTAS DE TERRENO</Text>
            <Text style={{ marginTop: 10 }}>PAGO DE REFACCIONARIOS</Text>
            <Text style={{ marginTop: 10 }}>INTERESES POR CREDITO</Text>
            <Text style={{ marginTop: 10 }}>IMPUESTOS</Text>
            <Text style={{ marginTop: 10 }}>GASTOS FAMILIARES</Text>
            <Text style={{ marginTop: 10 }}>OTROS EGRESOS</Text>
          </View>

        </View>
        <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
          <View style={{ marginTop: 5 }}>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_agricolas)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_ganaderos)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_maquilas)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_terrenos)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_refaccionarios)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_intereses)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_impuestos)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_familiares)}</Text>
            <Text style={{ marginTop: 10 }}>{FormatMoney(estadoresultados.eg_otros)}</Text>

          </View>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: 30,
          marginRight: 30,
          fontSize: 10,
          fontFamily: "RobotoFamily",
          marginTop: 10,
          backgroundColor: "#ccc",
        }}
      >
        <View style={{ width: 287 }}>
          <Text style={styles.label}>TOTAL INGRESOS</Text>
        </View>
        <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
          <Text style={styles.label}>{FormatMoney(totalIngresos)}</Text>
        </View>

        <View style={{ width: 287 }}>
          <Text style={styles.label}>TOTAL EGRESOS</Text>
        </View>
        <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
          <Text style={styles.label}>{FormatMoney(totalEgresos)}</Text>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          marginLeft: 30,
          marginRight: 30,
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
          backgroundColor: "#ccc",
        }}
      >
        <View>
          <Text>INGRESOS - EGRESOS</Text>
        </View>
        <View style={{ width: 70, textAlign: "right", paddingRight: 5 }}>
          <Text style={styles.label}>{FormatMoney(total)}</Text>
        </View>
      </View>
    </View>
  );
};
const renderOtrosIngresos = (otrosingresos) => {
  if (!otrosingresos || otrosingresos.length === 0) {
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>OTROS INGRESOS</Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 357 }}>
          <Text>FUENTE</Text>
        </View>
        <View style={{ width: 357 }}>
          <Text>INGRESO</Text>
        </View>
      </View>

      <View>
        {otrosingresos.map((ingresos, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              fontSize: 10,
              marginLeft: 30,
              marginRight: 30,
              borderBottomWidth: 1,
              borderColor: "#afb69d",
              marginTop: 5,
            }}
          >
            <Text style={{ width: 357 }}>{ingresos.fuente}</Text>
            <Text style={{ width: 357 }}>{ingresos.ingresos}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};
const renderSiniestros = (siniestros) => {
  if (!siniestros || siniestros.length === 0) {
    return (
      <Text style={styles.paragraph}>
        No hay información de medios de contacto.
      </Text>
    );
  }

  return (
    <View>
      <View
        style={{
          backgroundColor: "#275027",
          color: "#fff",
          height: 20,
          marginLeft: 30,
          marginRight: 30,
          justifyContent: "center",
          alignItems: "center",
          fontSize: 14,
          fontFamily: "RobotoFamily",
          marginTop: 15,
        }}
      >
        <Text>SINIESTROS</Text>
      </View>
      <View
        style={{
          flexDirection: "row",
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30,
          backgroundColor: "#ccc",
          fontFamily: "RobotoFamily",
        }}
      >
        <View style={{ width: 169 }}>
          <Text>SINIESTRO</Text>
        </View>
        <View style={{ width: 119 }}>
          <Text>PAGO TOTAL</Text>
        </View>
        <View style={{ width: 119 }}>
          <Text>PAGO PARCIAL </Text>
        </View>
        <View style={{ width: 119 }}>
          <Text>INDEMNIZACION </Text>
        </View>
        <View style={{ width: 119 }}>
          <Text>MONTO </Text>
        </View>
        <View>
          <Text style={{ width: 69 }}>CICLO </Text>
        </View>
      </View>

      <View>
        {siniestros.map((siniestro, index) => (
          <View
            key={index}
            style={{
              flexDirection: "row",
              fontSize: 10,
              marginLeft: 30,
              marginRight: 30,
              borderBottomWidth: 1,
              borderColor: "#afb69d",
              marginTop: 5,
            }}
          >
            <Text style={{ width: 169 }}>{siniestro.siniestro}</Text>
            <Text style={{ width: 119 }}>{FormatMoney(siniestro.ptotal)}</Text>
            <Text style={{ width: 119 }}>
              {FormatMoney(siniestro.pparcial)}
            </Text>
            <Text style={{ width: 119 }}>
              {siniestro.indemnizacion ? "Si" : "No"}
            </Text>
            <Text style={{ width: 119 }}>{FormatMoney(siniestro.monto)}</Text>
            <Text style={{ width: 69 }}>{siniestro.ciclo}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const ReporteGeneralPDF = ({ folio }) => {
  const [impresion, setImpresion] = useState({
    datosgenerales: {},
    contactos: [],
    domicilios: [],
    cultivos: [],
    balancepatrimonial: {},
    estadoresultados: {},
    otrosingresos: [],
    siniestros: [],
    vendedor:{}
  });
  const [loader, setLoader] = useState({ mostrar: false });
  useEffect(() => {
    request
      .get(`SolicitudImpresion/PDF?folio=${folio}`)
      .then((result) => {

        setImpresion({
          datosgenerales: result.datosgenerales,
          contactos: result.contactos,
          domicilios: result.domicilios,
          cultivos: result.cultivos,
          balancepatrimonial: result.balancepatrimonial,
          estadoresultados: result.estadoresultados,
          otrosingresos: result.otrosingresos,
          siniestros: result.siniestros,
          vendedor:result.vendedor
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
      });
  }, []);

  // const vendedor = () => {
  //   vendedor: vendedor.vendedor
  // }
  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        <View style={styles.titulo}>
          <Text style={styles.tituloTexto}>SOLICITUD DE CREDITO</Text>
        </View>
        <View style={styles.imagenContainer}>
          <Image src={Logo} style={styles.logoImagen} />
        </View>
        <View>
          <DatosPrincipales folio={folio} vendedor={impresion.vendedor} sucursal={impresion.vendedor}/>
        </View>
        <View>
          <View
            style={{
              backgroundColor: "#275027",
              color: "#fff",
              height: 20,
              marginLeft: 30,
              marginRight: 30,
              justifyContent: "center",
              alignItems: "center",
              fontSize: 14,
              fontFamily: "RobotoFamily",
              marginTop: 15,
            }}
          >
            <Text>DATOS GENERALES</Text>
          </View>
          <View>
            <DatosGenerales datosgenerales={impresion.datosgenerales} />
          </View>
        </View>
        <View>{renderContactos(impresion.contactos)}</View>
        <View>{renderDomicilios(impresion.domicilios)}</View>
        {/* <View>{renderCultivos(impresion.cultivos)}</View> */}
      </Page>
      {/* <Page size="A4" style={styles.page}>
        <View>
          <View style={styles.titulo}>
            <Text style={styles.tituloTexto}>SOLICITUD DE CREDITO </Text>
          </View>
          <View style={styles.imagenContainer}>
            <Image src={Logo} style={styles.logoImagen} />
          </View>

          <View>
            <View>{renderBalancePatrimonial(impresion.balancepatrimonial)}</View>
          </View>
        </View>
      </Page> */}
      {/* <Page>
        <View>
          <View style={styles.titulo}>
            <Text style={styles.tituloTexto}>SOLICITUD DE CREDITO</Text>
          </View>
          <View style={styles.imagenContainer}>
            <Image src={Logo} style={styles.logoImagen} />
          </View>
          <View>
            <View>{renderEstadoResultados(impresion.estadoresultados)}</View>
            <View>{renderOtrosIngresos(impresion.otrosingresos)}</View>
            <View>{renderSiniestros(impresion.siniestros)}</View>
          </View>
        </View>
      </Page> */}
    </Document>
  );
};

export default ReporteGeneralPDF;
